import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import "./styles/fonts.scss";
import "./styles/app.scss";
import "./styles/invitation.scss";
import "./styles/site.scss";
import "./styles/exclusive.scss";
import "./styles/kids.scss";
import "./styles/landing.scss";
import "./styles/seasons.scss";
import "./styles/keepsake.scss";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { FeedbackProvider } from "./context/FeedbackContext";
import { SeasonProvider } from "./context/SeasonContext";
import { CatalogProvider } from "./context/CatalogContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <FeedbackProvider>
        <SeasonProvider>
          <CatalogProvider>
            <App />
          </CatalogProvider>
        </SeasonProvider>
      </FeedbackProvider>
    </AuthProvider>
  </React.StrictMode>
);
